import * as React from 'react'
import { Link } from 'react-router-dom'
import '../Nav.css'

function Navbar() {
  return (
    <div className='navbar'>
        <ul className='navbar-menu'>
            <li><Link className="nav-link" to="/">Home</Link></li>
            <li><a className="nav-link" href="https://twitch.tv/ExtincTay">Twitch</a></li>
        </ul>
    </div>
  )
}

export default Navbar
